<div class="dialog-component">
  <div class="container">
    <div class="dialog-body">
      <app-registration-list
        [toolchainRegistration]="toolchainRegistration()"
        (newItemEvent)="updateItems($event)"></app-registration-list>
    </div>
  </div>
  <div class="control">
    <button [disabled]="isLoading()" (click)="cancel()" mat-stroked-button>Cancel</button>
    <button [disabled]="isLoading()" (click)="apply()" color="primary" mat-raised-button>
      Apply
    </button>
  </div>
</div>
